import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { RouterModule } from '@angular/router';
import { SharedModule } from 'avn/shared/shared.module';

import { AboutAvaanaComponent } from './about-avaana/about-avaana.component';
import { FeaturedInComponent } from './featured-in/featured-in.component';
import { FindInSuburbComponent } from './find-in-suburb/find-in-suburb.component';
import { HealthHubComponent } from './health-hub/health-hub.component';
import { HomeComponent } from './home/home.component';
import { ServiceItemComponent } from './home/service-item/service-item.component';
import { TopCategoriesComponent } from './home/top-categories/top-categories.component';
import { ListYourBusinessComponent } from './list-your-business/list-your-business.component';
import { WorkplaceWellbeingHomeComponent } from './workplace-wellbeing-home/workplace-wellbeing-home.component';

@NgModule({
  declarations: [
    HomeComponent,
    ListYourBusinessComponent,
    HealthHubComponent,
    WorkplaceWellbeingHomeComponent,
    FindInSuburbComponent,
    FeaturedInComponent,
    AboutAvaanaComponent,
    ServiceItemComponent,
    TopCategoriesComponent
  ],
  imports: [CommonModule, FormsModule, RouterModule, MatDatepickerModule, SharedModule],
  exports: [HealthHubComponent]
})
export class HomeModule {}
